<template lang="pug">
  v-container(wrap)
    v-layout
      formStepper(:model ='model', :field='field' :onSave='updateItem' @onClose='$emit("close")' :context ='currentContext')
</template>
<script>

  import Stepper from './Stepper.vue'
  export default {
    components: {
      formStepper: Stepper,
    },
    props: {
      currentContext: String,
    },
    data: () => ({
      model: {
        username: null,
        category: null,
        type: 'posts',
        title: null,
        content: null,
        image: null,
        audio: null,
        id: null,
      },

    }),
    computed: {

      field () {
        return {
          categories: {
            choices: [
              { text: 'Accident', value: 'accident' },
              { text: 'Vandalism', value: 'vandalism' },
              { text: 'Home invasion', value: 'home_invasion' },
              { text: 'Crimes', value: 'crimes' },
              { text: 'Historic events', value: 'historic_events' },
              { text: 'Humanitarian', value: 'humanitarian' },
              { text: 'Unusual vacation spots', value: 'unusual_vacation_spots' }],
          },
          types: {
            choices: this.currentContext === 'posts' ? ['News', 'Article', 'Blog'] : this.currentContext === 'static' ? ['Static', 'Policies'] : [],
          },
        }
      },
      icon () {
        const category = this.model.category
        let categoryIcon = null
        switch (category) {
          case 'nation':
            categoryIcon = 'mdi-alpha-n-box'
            break
          case 'economy':
            categoryIcon = 'mdi-alpha-e-box'
            break
          case 'life':
            categoryIcon = 'mdi-alpha-v-box'
            break
          case 'international':
            categoryIcon = 'mdi-alpha-i-box'
            break
          case 'trending':
            categoryIcon = 'mdi-alpha-v'
            break
          case 'sports':
            categoryIcon = 'mdi-alpha-d-box'
            break
          case 'entertainment':
            categoryIcon = 'mdi-alpha-e'
            break
          case 'technology':
            categoryIcon = 'mdi-alpha-c-box'
            break
        }
        return categoryIcon
      },
      currentPost () {
        return this.$store.getters['cms/getCurrentPost']
      },
    },
    watch: {
      currentPost (val) {
        this.getCurrentItem()
      },
    },
    mounted () {
      this.getCurrentItem()
    },
    methods: {
      // añadir static post para editar
      getCurrentItem () {
        this.model = this.$store.getters['cms/getCurrentPost']
      },
      updateItem () {
        // A post entry.
        const vm = this
        const itemData = {
          username: vm.model.username,
          uid: vm.model.uid,
          type: vm.model.type,
          title: vm.model.title,
          content: vm.model.content,
          image: vm.model.image,
          subject: vm.model.subject,
          audio: vm.model.audio,
          icon: vm.icon,
          id: vm.model.id,
        }
        vm.$store.commit('cms/setLoading', true)
        vm.$forceUpdate()
        setTimeout(function () {
          // console.log(vm.currentContext, itemData)
          vm.$store.dispatch('cms/updateItem', { context: vm.currentContext, data: itemData }).then(() => {
            vm.onSuccess()
          })
        }, 1000)
      },
      onSuccess () {
        this.model = {
          username: null,
          type: null,
          title: null,
          content: null,
          image: null,
          audio: null,
          subject: null,
        }
        this.$store.dispatch('cms/clearSelected').then(() => {
          // cleared
        })
        // this.$router.push({ name: 'Posts' })
      },
      setImage (image) {
        this.model.imagen = image
      },
    },
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .ql-video {
    max-width: 100%;

  }
  img{
    max-width: 100%;
    height:auto;
  }
</style>
